type CustomDataFilterItem = {
  field_index?: number | null;
  field_value?: string | null;
};

/**
 * Normalizes custom_data search filters: trims values, assigns field_index, drops empties.
 */
export function normalizeCustomDataFilter<T extends CustomDataFilterItem>(
  customDataArray: T[] | undefined | null,
): T[] | undefined {
  if (!customDataArray?.length) {
    return undefined;
  }

  const out: T[] = [];

  customDataArray.forEach((item, i) => {
    const value = typeof item.field_value === "string" ? item.field_value.trim() : "";

    if (value === "") {
      return;
    }

    const fieldIndex =
      item.field_index !== undefined &&
      item.field_index !== null &&
      Number.isFinite(Number(item.field_index))
        ? Number(item.field_index)
        : i;

    out.push({ ...item, field_index: fieldIndex, field_value: value } as T);
  });

  return out.length > 0 ? out : undefined;
}
